import ResourceCard from "../../components/ResourceCard.vue";
import CardHeader from "@/pages/components/CardHeader";
import { Empty } from "zhs-components";
export default {
  components: {
    ResourceCard,
    Empty,
    CardHeader
  },
  props: {
    courseType: Number,
    menu: Object,
    userInfo: {
      type: Object,
      default: null
    }
  },

  created() {},

  data() {
    return {
      homeCourseList: [],
      courseCategorys: [],
      abbr: this.$config.abbr,
      classId: undefined,
      authType: 0,
      hiddenMoreClass: true,
      typeId: "",
      resourceList: [{
        id: "1",
        name: "运动性疲劳及恢复过程的生化特点",
        resourceUrl: "https://hike-doc-online-h5.zhihuishu.com/alweb.html?WOPISrc=https://file.zhihuishu.com/zhs/ablecommons/demo/202112/753a4c16fc6747e39a9f02545e4c895e.ppt",
        uploadTime: "2021-12-09",
        type: "ppt",
        viewNum: 23,
        sendNum: 3,
        downNum: 17,
        coverUrl: require("../../../assets/images/resource_image/1.png")
      }, {
        id: "2",
        name: "电力工程项目进度计划",
        resourceUrl: "https://hike-doc-online-h5.zhihuishu.com/alweb.html?WOPISrc=https://file.zhihuishu.com/zhs/ablecommons/demo/202112/0ffd264bfece4cb9b975ba980552ac0e.ppt",
        uploadTime: "2021-12-09",
        type: "ppt",
        viewNum: 10,
        sendNum: 0,
        downNum: 2,
        coverUrl: require("../../../assets/images/resource_image/2.png")
      }, {
        id: "3",
        name: "能源与新能源发电技术",
        resourceUrl: "https://hike-doc-online-h5.zhihuishu.com/alweb.html?WOPISrc=https://file.zhihuishu.com/zhs/ablecommons/demo/202112/166ea94303dd43af91873cf5b95448e3.ppt",
        uploadTime: "2021-12-08",
        type: "ppt",
        viewNum: 15,
        sendNum: 1,
        downNum: 6,
        coverUrl: require("../../../assets/images/resource_image/3.png")
      }, {
        id: "4",
        name: "微方程基本概念",
        resourceUrl: "https://hike-doc-online-h5.zhihuishu.com/alweb.html?WOPISrc=https://file.zhihuishu.com/zhs/ablecommons/demo/202112/ec9edb4b32614776b922cbf6ad353424.pptx",
        uploadTime: "2021-12-11",
        type: "ppt",
        viewNum: 34,
        sendNum: 4,
        downNum: 21,
        coverUrl: require("../../../assets/images/resource_image/4.png")
      }]
    };
  },

  methods: {
    toggleUserRole() {}

  }
};